export default {
  homePage: 'ホーム',
  chatPage: 'チャット',
  contactUs: 'お問い合せ',
  submitRequest: 'お問い合わせを送信する',
  question: '質問する',
  subject: '件名',
  description: 'お問い合わせの説明',
  email: 'メールアドレス',
  attach: '最大4つのファイルを添付してください。ファイルのサイズは10MBまでです。',
  delete: '削除する',
  sizeExceeded: 'ファイルのサイズは10MBまでです。',
  numberExceeded: '最大4つのファイルを添付できます。',
  wrongFormat: 'アップロードすることのできるファイル形式は、.jpg,、.jpeg、 .png、.bmp、.tif、.tiff、.gif、.webp、.avi、.mp4、.mov、.flv、.mkv、.webm、.txt、.csv のみとなります。',
  send: '送信する',
  type: 'ご質問の種別を選択してください。',
  messageSent: 'メッセージは正常に送信されました。サポートチームがお客様の要求を確認した後、入力いただいたメールアドレス宛てに連絡させていただきます。',
  formUnavailable: '現在、チケット作成フォームはご利用いただけません。 ヘルプセンターからチケットを送信ください。',
  helpCenter: 'ヘルプセンターへ',
  issueEmpty: 'ご質問の種別を選択してください。',
  subjEmpty: 'お問い合わせの件名を入力してください。',
  descEmpty: 'ご質問を入力してください。',
  emailInvalid: 'メールアドレスを入力してください。入力したメールアドレスが正しいことを確認してください。',
  // Issue types
  type: 'ご質問の種別を選択してください。',
  gameQuestion: 'ゲームに関する質問',
  techIssue: '技術的な問題',
  paymIssue: '購入に関する問題',
  gameplayIssues: 'ご意見・ご要望',
  feedback: 'ご意見・ご要望',
  dpo: 'プライバシー保護のリクエスト・DPOを連絡する',
  // GDPR form
  gdprCheckbox: `上記の条件を読み、理解しました。`,
  gdprType: '削除したい理由を選択してください（任意）',
  gdprRestart: 'ゲームを最初からやりなおしたい',
  gdprBored: `ゲームが楽しくない`,
  gpdrMultiacc: `別のアカウントがあり、このアカウントが必要ない`,
  gdprExpectations: `ゲームは期待したものに届かなかった`,
  gdprDataSafety: `個人データを共有したくない`,
  gdprPrices: 'ゲームはお金がかかりすぎる',
  gdprOther: '他',
  gdprCreate: `<p>こちらからアカウントと関連するデータの完全な削除をリクエストできます。特定のサーバー上のゲームプロフィールのみを削除したい場合は、メインゲーム画面の歯車のアイコンをクリックして、下にスクロールし、［サポート］オプションの隣にある［開く］をクリックしてください。次に、チャットで、［アカウントとプライバシー］→［アカウントを削除］→［サーバー上のプロフィールを削除］の順番でアクセスします。 </p>
<p>データの削除を選択する場合、すべての進捗、スコア、実績は削除されます。<strong>お客様の進捗はすべてのサーバーで不可逆的に削除されます。また、お客様のデータは当社のサーバーでも削除されます</strong>。</p>
<p>当社は法律の要件に厳密に従い、お客様のデータを保護し、お客様の権利を尊重いたします。当社が収集するデータは、お客様がプロジェクトにアクセスするために必要なものです。当社がお客様のデータ削除リクエストが完了した後に、お客様がプロジェクトを実行する場合、お客様はもう一度、当社の<a href="https://www.nexters.com/hwa/tos_ja/">規約</a>と<a href="https://www.nexters.com/hwa/privacy_ja/">プライバシーポリシー</a> に同意する必要があります。この場合、当社はお客様のデータの収集を再開します。お客様のリクエストが完了するまで、お客様は<a href="https://www.nexters.com/hwa/tos_ja/">規約と<a href="https://www.nexters.com/hwa/privacy_ja/">プライバシーポリシー</a>に追加で同意することなく、進捗と実績にアクセスできます。</p>
<p>このリクエストを確定する場合、確定日から 30 日以内にリクエストが完了されます。また、この期間は最大の期間であることをご留意ください。したがって、当社は社内のリクエスト処理手順に従い、30 日よりも前にリクエストを完了する場合があります。データの削除をリクエストする際、このプロセスは不可逆的なものであることにご注意ください。</p>
さらに、お客様が心変わりされる場合、リクエストを撤回できる期限（14 日以内）があります。リクエストのキャンセル方法：
<ol><li>メインゲーム画面の右上隅にある歯車のアイコンをクリックして、下へスクロールし、［ゲームサーバーからアカウントのすべてのデータを削除］オプションの隣にある［開く］をクリックしてください。すると、［キャンセル］ボタンが表示されます。そのボタンをクリックして、リクエストをキャンセルします。</li>
<li>上記の方法の代わりに、チャットボットを使ってリクエストをキャンセルすることもできます。メインゲーム画面の右上隅にある歯車のアイコンをクリックして、下へスクロールし、［サポート］オプションの隣にある［開く］をクリックします。次にチャットで、［アカウントとプライバシー］→［アカウントを削除］→［Hero Wars アカウントを削除］→［アカウントの削除リクエストをキャンセル］の順番でアクセスします。</li></ol>
<p>上記の条件に同意し、続行を希望する場合は、［確定］をクリックしてください。</p>
`,
  confirm: '確定',
  gdprConfirmed1: 'お客様の削除リクエストが受理されました。すべてのサーバー上のすべての進捗は、リクエストの確定日から 30 日以内に不可逆的に削除されます。確定日：',
  gdprConfirmed2: `<p>最初の 14 日以内でしたら、このリクエストをキャンセルできます。リクエストをキャンセルするには、次の手順に従ってください：
<ol><li>メインゲーム画面の右上隅にある歯車のアイコンをクリックして、下へスクロールし、［ゲームサーバーからアカウントのすべてのデータを削除］オプションの隣にある［開く］をクリックしてください。すると、［キャンセル］ボタンが表示されます。そのボタンをクリックして、リクエストをキャンセルします。</li>
<li>上記の方法の代わりに、チャットボットを使ってリクエストをキャンセルすることもできます。メインゲーム画面の右上隅にある歯車のアイコンをクリックして、下へスクロールし、［サポート］オプションの隣にある［開く］をクリックします。次にチャットで、［アカウントとプライバシー］→［アカウントを削除］→［Hero Wars アカウントを削除］→［アカウントの削除リクエストをキャンセル］の順番でアクセスします。</li></ol></p>
<p>リクエストの作成日から起算して 7 日目および 14 日目に、ゲーム内メールにリマインダーが送られてきます。<strong>14 日経つとアカウントの削除リクエストをキャンセルできなくなることにご留意ください。</strong></p>`,
  gdprCancel: `<p>アカウントの削除リクエストをキャンセルしたい場合は、［アカウントの削除をキャンセル］をクリックしてください。</p>`,
  gdprCancelConfirmed: `<p>当社は法律の要件に厳密に従い、お客様のデータに適切なレベルの保護を施し、お客様の権利を尊重いたします。</p>
  <p><strong>お客様のリクエストに基づき、削除リクエストは撤回されました。進捗は削除されません。</strong></p>
  <p>今後もデータが収集されることにご留意ください。</p>`,
  gdprCancelButton: `アカウントの削除をキャンセル`,
  // Meya 
  digestEmpty: 'こんにちは。ゲームに関してご質問がありましたら、サポートチームが喜んでお手伝いいたします。',
  loadingChat: 'チャットを読み込んでいます…',
  loadingChatStart: `チャットボタンが表示されない場合は、`,
  loadingChatLink: `こちら `,
  loadingChatEnd: `からご連絡ください。`,
  openChat: 'チャット',
  // Links
  hcLink: 'https://support-hwa.nexters.com/hc/ja',
  // Help Center
  popularTopics: 'ピックアップ記事',
  search: '検索',
  searchResults: 'の検索結果',
  showAll: 'すべて表示',
  error: '問題が発生しました。後で再度お試しください。',
}